module.exports = __webpack_public_path__ + "js/components/images/zapcash-7eb96b0cff0ce1bc9bd496cf61d0b7b2.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/zapcash.svg
// module id = 828
// module chunks = 31